import { useState, useEffect, useCallback } from "react";

function useTreeScroll(containerRef) {
  const [progress, setProgress] = useState(0);

  const update = useCallback(() => {
    const el = containerRef.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const scrollable = el.scrollHeight - window.innerHeight;
    const scrolled = -rect.top;
    const p = scrollable > 0 ? Math.max(0, Math.min(scrolled / scrollable, 1)) : 0;
    setProgress(p);
  }, [containerRef]);

  useEffect(() => {
    let ticking = false;
    const onScroll = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          update();
          ticking = false;
        });
        ticking = true;
      }
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    update();
    return () => window.removeEventListener("scroll", onScroll);
  }, [update]);

  return progress;
}

export default useTreeScroll;
